import gql from 'graphql-tag';

export const degreeEnrollmentChecklistsV1Mutation = gql`
  mutation degreeEnrollmentChecklistsV1Mutation($id: String!, $body: String) {
    DegreeEnrollmentChecklistsV1(id: $id, body: $body)
      @rest(
        type: "DegreeEnrollmentChecklistsV1Resource"
        path: "degreeEnrollmentChecklists.v1?id={args.id}&action=enableChecklist"
        method: "POST"
        bodyKey: "body"
      ) {
      elements {
        id
      }
    }
  }
`;

export default degreeEnrollmentChecklistsV1Mutation;
